$(document).ready((e) => {
  const lastFocusedSearchType = '';
  if ($('input[name="term-tmp"]').length == 0) {
    $('input[name="term"]').attr('name', 'term-tmp');
  }

  $('input[name="term-tmp"]').removeAttr('disabled');

  $('#searchForm').submit(function (e) {
    const searchType = 'submit-term';

    if ($(this).find('input.hidden-type').length > 0) {
      $(this).find('input.hidden-type').val(lastFocusedSearchType);
    } else {
      const input = $('<input>')
          .attr('class', 'hidden-type')
          .attr('name', 'type')
          .attr('type', 'hidden')
          .val(searchType);
      $(this).append(input);
    }

    if ($('input[name="term"]').length > 0) {
      $('input[name="term"]').val(encodeURIComponent($('input[name="term-tmp"]').val()));
    } else {
      const inputTerm = $('<input>')
          .attr('name', 'term')
          .attr('type', 'hidden')
          .val(encodeURIComponent($('input[name="term-tmp"]').val()));
      $(this).append(inputTerm);
    }

    $('input[name="term-tmp"]').attr('disabled', 'disabled');
  });
});
